import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import BefehlFormWrapper from '../Generic/BefehlFormWrapper'
import { BefehlFormProps } from '../Generic'
import {
  convertBefehl3FormDataToModel,
  convertModelToBefehl3FormData
} from './converters'
import Auftrag3_10Form from './Auftrag3_10Form'
import Auftrag3_15Form from './Auftrag3_15Form'
import Auftrag3_20Form from './Auftrag3_20Form'
import { Befehl3 } from '../../../models'
import { Befehl3FormData, createBefehl3FormValidationSchema } from './schema'

/**
 * Main form component for Befehl 3
 */
export default function Befehl3Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-3-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl3>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl3FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl3FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl3FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl3FormData) => {
      const updatedBefehl = convertBefehl3FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl3FormData>
      befehlKennung="3"
      title={t('befehle.3.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      displayHeaderOnly={displayHeaderOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      {/* Auftrag 3.10 */}
      <Auftrag3_10Form
        data-testid={`${testId}-auftrag-3-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
      {/* Auftrag 3.15 */}

      <Auftrag3_15Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-3-15`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
      {/* Auftrag 3.20 */}

      <Auftrag3_20Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-3-20`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
